import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-empty-dialog',
  templateUrl: './empty-dialog.component.html',
  styleUrls: ['./empty-dialog.component.scss']
})
export class EmptyDialogComponent implements OnInit {

  constructor( @Inject(MAT_DIALOG_DATA) public data: any,) { }
  title:string = '';
  resolutionHeader = [{
    label: 'Sanctioned Date',
    key: 'sanctionedDate'
  },{
    label:'Sanctioned Amount',
    key:'sanctionAmount'
  },{
    label:'Loan Type',
    key:'loanType'
  },{
    label:'Loan Account Number',
    key:'loanAccountNumber'
  },{
    label:'Interest Rate',
    key:'interestRate'
  },{
    label:'No. of Installment',
    key:'installmentNumber'
  },{
    label:'DP Limit',
    key:'dpLimit'
  },{
    label:'Disbursed Amount',
    key:'disbursedAmount'
  },{
    label:'Emi',
    key:'emi'
  }];

 resolutionTable = []

  ngOnInit(): void {
    this.resolutionHeader = this.data.resolutionHeader || [];
    this.resolutionTable = this.data.resolutionTable || [];
    this.title = this.data.title || '';
  }

}
